<template>
  <a-form-item :label="field.name">
    <a-input-number placeholder="Nhập số" :value="value" @change="onChange" />
  </a-form-item>
</template>
<script>
export default {
  props: {
    field: {
      type: Object,
      required: true,
    },
    value: [Number, String],
  },
  methods: {
    onChange(event) {
      this.$emit("input", event);
    },
  },
};
</script>
